import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import DealsIndex from './pages/DealsIndex.vue';
import DealsKanban from './pages/DealsKanban.vue';
import DealDetailView from './pages/DealDetailView.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    component: DealsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'deals_dashboard_index',
        component: DealsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/deals/kanban'),
    name: 'deals_kanban',
    component: DealsKanban,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/deals/:dealId'),
    name: 'deals_detail',
    component: DealDetailView,
    meta: commonMeta,
  },
];
